import { Event } from "../../handlers/events.constant"
import { SENDER } from "../../../shared/sender"
export const isOutsideEvent = (event: Event) => {
	if (event.sender === SENDER.toString()) return false
	return true
}
